"use client";
import { useEffect, useState } from "react";

const ProgressiveImage = ({
  url,
  className,
  style,
}: {
  url?: any;
  style?: any;
  className?: any;
}) => {
  const [status, setStatus] = useState("loading");
  useEffect(() => {
    const img = new Image();

    img.onload = () => {
      setStatus("success");
    };
    img.onerror = () => {
      setStatus("error");
    };
    img.src = url;
    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [url]);

  if (status === "loading") {
    return (
      <img alt=""
        style={style}
        loading="lazy"
        src={
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Placeholder_view_vector.svg/991px-Placeholder_view_vector.svg.png"
        }
        className={className}
      />
    );
  } else if (status === "error") {
    return (
      <img alt=""
        style={style}
        loading="lazy"
        src={
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Placeholder_view_vector.svg/991px-Placeholder_view_vector.svg.png"
        }
        className={className}
      />
    );
  } else {
    return <img alt="" style={style}  draggable="false" loading="lazy" src={url} className={className} />;
  }
};

export default ProgressiveImage;
